import React, {Component} from 'react';

import {withFirebase } from '../Firebase';
import './index.css';
import CsvDownload from 'react-json-to-csv'

class Challenges extends Component {

    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            challenge_details: [], 
            totalMemberCount: {}, 
            totalSubmissionCount: {}, 
            submissions: {},
            
        };
    }

    componentDidMount() {
       
        this.setState({ loading: true});
      
        this.unsubscribe = this.props.firebase.challenges().onSnapshot( snapshot => {

            let challenge_details = [];
            let totalMemberCount = [];
            let totalSubmissionCount = []; 
            let submission = []; 
            snapshot.forEach( 
                doc => {
                    
                    let challenge_id = doc.id; 
                    if(challenge_id === "kic50NOP1zeg6y5Dhq2l" )
                    {

                    
                    let nTeams = doc.data().round_one.teams.length; 
                    nTeams =  challenge_id === "kic50NOP1zeg6y5Dhq2l" ?   nTeams - 100 : nTeams; 
                    let i = challenge_id === "kic50NOP1zeg6y5Dhq2l" ?   100 : 0; 
                    
                    let realNTeams =  doc.data().round_one.teams.length; 
                    totalSubmissionCount[challenge_id] = 0; 
                    totalMemberCount[challenge_id]  = 0; 
                    submission[challenge_id] = []; 
                    for(i ; i < realNTeams; i ++)
                    {
                        
                        doc.data().round_one.teams[i].team.get().then(
                            doc => {
                                let team = {...doc.data(), id: doc.id}; 
                              
                                if(team === undefined)
                                    {
                                        totalMemberCount[challenge_id] =  0 ; 
                                        this.setState({"totalMemberCount": totalMemberCount})
                                        return; 
                                    }
                                if(team.hasOwnProperty("members"))
                                    {
                                        totalMemberCount[challenge_id]+= team.members.length; 
                                        submission[challenge_id].push(this.generateJsonRecord(team))
                                        
                                    }
                                if(team.hasOwnProperty("submissions"))
                                    {
                                        totalSubmissionCount[challenge_id]++; 
                                    }
                                this.setState({totalMemberCount: totalMemberCount, 
                                              totalSubmissionCount: totalSubmissionCount, 
                                                    submissions: submission })
                            }

                        )

                        
                    
                    }
                    
                    challenge_details.push({
                        nTeams: nTeams,
                        cid: challenge_id,
                        nMembers: this.state.membersCounter,
                        name:  doc.data().hasOwnProperty("name") ? doc.data().name : " ",
                    })

                }
                   
                }
            )
            this.setState({challenge_details: challenge_details})
           
            })

        
    
        
        this.setState({ loading: false});
    

    
    }

    componentWillMount() {
        this.unsubscribe && this.unsubscribe();
    }


    generateJsonRecord = (team_doc) => {

        var record = {}
     
    
        record["id"] = team_doc.id; 
        record["team_name"] = team_doc.team_name; 
        record["nmembers"] = team_doc.members.length; 
       
        record["idea"] =  team_doc.hasOwnProperty("submissions") ? team_doc.submissions[0].idea : "-";
        record["problem"] =  team_doc.hasOwnProperty("submissions") ? team_doc.submissions[0].problem : "-";
        record["target"] =  team_doc.hasOwnProperty("submissions") ? team_doc.submissions[0].target : "-";
        record["value_add"] =  team_doc.hasOwnProperty("submissions") ? team_doc.submissions[0].value_add : "-";
        record["next_step"] =  team_doc.hasOwnProperty("submissions") ? team_doc.submissions[0].next_step : "-";
        record["stage"] =  team_doc.hasOwnProperty("submissions") ? team_doc.submissions[0].stage : "-";
    
        var members = team_doc.members; 
        var n_members = team_doc.members.length; 
        for (var i = 0 ; i < n_members ; i++)
        {
            if(members[i].isLeader === true)
            {
                record[`leader_name`] = members[i].name;
                
            }
            
            record[`member_name_${i}`] = members[i].name;
            record[`member_phone_${i}`] = members[i].phone;
            record[`member_email_${i}`] = members[i].email;
    
            record[`member_specialization_${i}`] = members[i].hasOwnProperty("specialization") ? members[i].specialization : "-";
            record[`member_cv_${i}`] = members[i].hasOwnProperty("cv") ? members[i].cv : "-";
         
        }
    
        for( i = n_members; i < 5 ; i++){
    
            record[`member_name_${i}`] = "-";
            record[`member_phone_${i}`] = "-";
            record[`member_email_${i}`] = "-";
    
            record[`member_specialization_${i}`] =  "-";
            record[`member_cv_${i}`] = "-";
        }
        
     
        if(team_doc.hasOwnProperty("submissions"))
        {
            var list = []; 
            var solution = team_doc.submissions[0].solution; 
            for(var i in  solution){
                list[i] = solution[i].url; 
            }      
            record["attachement"] = list;
        } else record["attachement"] = "-"; 
   

        return record; 
    
    
    }


    
    render() {

        const { challenge_details,totalMemberCount,totalSubmissionCount, submissions, loading} = this.state;

        console.log("totalMemberCount : ",totalMemberCount, " totalSubmissionCount: ", totalSubmissionCount);
       
        

        return(
            <div> 
                <h1 className="margin-left">Challenges Summary Board</h1>

            {loading && <div>Loading...</div>}    
            
            <ChallengeList challenges = {challenge_details} membersCount = {totalMemberCount} 
             submissionCount = {totalSubmissionCount} submissions = {submissions} getCsvFile = {this.getCsvFile}/>
          

            </div> 
            
        );
     }   
}


const ChallengeList =  ({challenges, membersCount, submissionCount, submissions, getCsvFile}) => (
    <ul>
        {challenges.map(challenge => (
            <li key={challenge.cid}>
                <span>
                    <strong>name: </strong> {challenge.name}
                </span>
                <span>
                    <strong>, number of teams: </strong> {challenge.nTeams}
                </span>
                <span>
                    <strong>, number of members: </strong> {membersCount[challenge.cid]}
                </span>
                <span>
                    <strong>, number of submissions: </strong> {submissionCount[challenge.cid]}
                </span>
                <span>
                    <strong>, download submissions: </strong> 
                    
                        
                         <CsvDownload data={submissions[challenge.cid]} /> 
        
                  
                 
                </span>
            </li>
        ))}
    </ul>
);

export default withFirebase(Challenges);